// extracted by mini-css-extract-plugin
export default {"container":"calculator_container__iFxnQ","card":"calculator_card__phNAT"};